import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Input, Output } from "@angular/core";

export enum RouteFeedback {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
  NEUTRAL = 'NEUTRAL'
}

require('./planning-route-action-menu.scss');
@Component({
  standalone: false,
  selector: 'app-planning-route-action-menu',
  templateUrl: './planning-route-action-menu.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlanningRouteActionMenuComponent {
  @Input() route: any;
  @Input() disabled: boolean = false;

  @Output() onDispatch = new EventEmitter<string>();
  @Output() onReoptimize = new EventEmitter<string>();
  @Output() onPreAssignAgent = new EventEmitter<string>();
  @Output() onPrint = new EventEmitter<string>();
  @Output() onPrintLoadingSheet = new EventEmitter<string>();
  @Output() onDelete = new EventEmitter<string>();
  @Output() onFeedback = new EventEmitter<{ routeId: string, feedback: RouteFeedback }>();

  readonly RouteFeedback = RouteFeedback;

  constructor(@Inject('confirmDialogService') private confirmDialogService: any) {}

  get isRunning(): boolean {
    return !!(this.route?.actionProcess?.running && (new Date().getTime() < this.route.actionProcess?.expirationDate));
  }

  get isMenuDisabled(): boolean {
    return this.disabled || !!this.route?.locked || this.isRunning;
  }

  deleteRoute(event: MouseEvent) {
    event.stopPropagation();
    this.onDelete.emit(this.route.id);
  }
}
